const KEY = 'sentinel:federated-step-up:pending';

export interface PendingRequest {
  url: string;
  method: string;
  body: string | null;
  headers: [string, string][];
}

export async function persistPendingRequest(request: Request): Promise<void> {
  const clone = request.clone();
  const body = ['GET', 'HEAD'].includes(clone.method.toUpperCase()) ? null : await clone.text();
  const pending: PendingRequest = {
    url: clone.url,
    method: clone.method,
    body: body && body.length > 0 ? body : null,
    headers: [...clone.headers.entries()],
  };
  sessionStorage.setItem(KEY, JSON.stringify(pending));
}

export function takePendingRequest(): PendingRequest | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  sessionStorage.removeItem(KEY);
  try {
    return JSON.parse(raw) as PendingRequest;
  } catch {
    return null;
  }
}

export function clearPendingRequest(): void {
  sessionStorage.removeItem(KEY);
}
